export const thisPeriodData = [
    {
        "start": "2025-04-23 00:00:00",
        "end": "2025-04-30 23:59:59",
        "unit_date": "2025-04-01",
        "total": 3,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 2
    },
    {
        "start": "2025-05-01 00:00:00",
        "end": "2025-05-31 23:59:59",
        "unit_date": "2025-05-01",
        "total": 3,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 2
    },
    {
        "start": "2025-06-01 00:00:00",
        "end": "2025-06-30 23:59:59",
        "unit_date": "2025-06-01",
        "total": 7,
        "dental": 0,
        "healthcare": 2,
        "non_healthcare": 5
    },
    {
        "start": "2025-07-01 00:00:00",
        "end": "2025-07-31 23:59:59",
        "unit_date": "2025-07-01",
        "total": 7,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 6
    },
    {
        "start": "2025-08-01 00:00:00",
        "end": "2025-08-31 23:59:59",
        "unit_date": "2025-08-01",
        "total": 5,
        "dental": 0,
        "healthcare": 2,
        "non_healthcare": 3
    },
    {
        "start": "2025-09-01 00:00:00",
        "end": "2025-09-30 23:59:59",
        "unit_date": "2025-09-01",
        "total": 8,
        "dental": 1,
        "healthcare": 2,
        "non_healthcare": 5
    },
    {
        "start": "2025-10-01 00:00:00",
        "end": "2025-10-23 03:59:59",
        "unit_date": "2025-10-01",
        "total": 1,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 0
    }
];

export const lastPeriodData = [
    {
        "start": "2024-10-21 00:00:00",
        "end": "2024-10-31 23:59:59",
        "unit_date": "2024-10-01",
        "total": 3,
        "dental": 1,
        "healthcare": 1,
        "non_healthcare": 1
    },
    {
        "start": "2024-11-01 00:00:00",
        "end": "2024-11-30 23:59:59",
        "unit_date": "2024-11-01",
        "total": 2,
        "dental": 0,
        "healthcare": 2,
        "non_healthcare": 0
    },
    {
        "start": "2024-12-01 00:00:00",
        "end": "2024-12-31 23:59:59",
        "unit_date": "2024-12-01",
        "total": 0,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 0
    },
    {
        "start": "2025-01-01 00:00:00",
        "end": "2025-01-31 23:59:59",
        "unit_date": "2025-01-01",
        "total": 5,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 4
    },
    {
        "start": "2025-02-01 00:00:00",
        "end": "2025-02-28 23:59:59",
        "unit_date": "2025-02-01",
        "total": 5,
        "dental": 1,
        "healthcare": 1,
        "non_healthcare": 3
    },
    {
        "start": "2025-03-01 00:00:00",
        "end": "2025-03-31 23:59:59",
        "unit_date": "2025-03-01",
        "total": 5,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 4
    },
    {
        "start": "2025-04-01 00:00:00",
        "end": "2025-04-22 23:59:59",
        "unit_date": "2025-04-01",
        "total": 3,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 2
    }
];

export const statesData = [
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "New York",
        "total_doctors": 8,
        "dental": 2,
        "healthcare": 0,
        "non_healthcare": 6
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Colorado",
        "total_doctors": 2,
        "dental": 1,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Illinois",
        "total_doctors": 1,
        "dental": 1,
        "healthcare": 0,
        "non_healthcare": 0
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Ohio",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Arizona",
        "total_doctors": 1,
        "dental": 1,
        "healthcare": 0,
        "non_healthcare": 0
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Florida",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Minnesota",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Wisconsin",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 1,
        "non_healthcare": 0
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Georgia",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Kentucky",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "Texas",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    },
    {
        "country_id": 1,
        "country_name": "United States",
        "country_code": "US",
        "state_name": "California",
        "total_doctors": 1,
        "dental": 0,
        "healthcare": 0,
        "non_healthcare": 1
    }
];

export const businessHighlightsGainerData = [
    {
        "doctor_id": 5690,
        "practice_name": "lalit",
        "doctor_name": "cfv dv",
        "current_period_count": 107,
        "previous_period_count": 19,
        "count_diff": 88
    },
    {
        "doctor_id": 95506,
        "practice_name": "testing purpose",
        "doctor_name": "test1 test2",
        "current_period_count": 13,
        "previous_period_count": 5,
        "count_diff": 8
    },
    {
        "doctor_id": 5273,
        "practice_name": "Best Credit",
        "doctor_name": "Andrew Joushua",
        "current_period_count": 11,
        "previous_period_count": 4,
        "count_diff": 7
    },
    {
        "doctor_id": 92835,
        "practice_name": "testing",
        "doctor_name": "Testing Pp",
        "current_period_count": 7,
        "previous_period_count": 2,
        "count_diff": 5
    },
    {
        "doctor_id": 8760,
        "practice_name": "blacklabelbusiness",
        "doctor_name": "Black Label",
        "current_period_count": 16,
        "previous_period_count": 11,
        "count_diff": 5
    },
    {
        "doctor_id": 10769,
        "practice_name": "Robert Health Care",
        "doctor_name": "Robert Steve",
        "current_period_count": 10,
        "previous_period_count": 7,
        "count_diff": 3
    },
    {
        "doctor_id": 94944,
        "practice_name": "Test1 Business",
        "doctor_name": "test1 test2",
        "current_period_count": 10,
        "previous_period_count": 7,
        "count_diff": 3
    },
    {
        "doctor_id": 95463,
        "practice_name": "ggggggggg",
        "doctor_name": "new busi",
        "current_period_count": 1,
        "previous_period_count": 1,
        "count_diff": 0
    },
    {
        "doctor_id": 95488,
        "practice_name": "X-ray crystallographer manufacturer",
        "doctor_name": "Rosalind Franklin",
        "current_period_count": 0,
        "previous_period_count": 1,
        "count_diff": -1
    },
    {
        "doctor_id": 95496,
        "practice_name": null,
        "doctor_name": "Aashima Mahajan",
        "current_period_count": 0,
        "previous_period_count": 1,
        "count_diff": -1
    }
];

export const activeBusinessesData = {
    "stats": {
        "total": 12,
        "dental": 1,
        "healthcare": 0,
        "non_healthcare": 11,
        "alltime_active_doctors": 62
    },
    "records": [
        {
            "start": "2025-04-25 00:00:00",
            "end": "2025-04-30 23:59:59",
            "unit_date": "2025-04-01",
            "total": 1,
            "dental": 0,
            "healthcare": 0,
            "non_healthcare": 1
        },
        {
            "start": "2025-05-01 00:00:00",
            "end": "2025-05-31 23:59:59",
            "unit_date": "2025-05-01",
            "total": 4,
            "dental": 0,
            "healthcare": 0,
            "non_healthcare": 4
        },
        {
            "start": "2025-06-01 00:00:00",
            "end": "2025-06-30 23:59:59",
            "unit_date": "2025-06-01",
            "total": 4,
            "dental": 0,
            "healthcare": 0,
            "non_healthcare": 4
        },
        {
            "start": "2025-07-01 00:00:00",
            "end": "2025-07-26 23:59:59",
            "unit_date": "2025-07-01",
            "total": 3,
            "dental": 1,
            "healthcare": 0,
            "non_healthcare": 2
        }
    ]
}

export const inactiveBusinessesData = {
  "stats": {
    "total": 546,
    "dental": 9,
    "healthcare": 11,
    "non_healthcare": 526,
    "alltime_inactive_doctors": 13473
  },
  "records": [
    {
      "start": "2025-04-25 00:00:00",
      "end": "2025-04-30 23:59:59",
      "unit_date": "2025-04-01",
      "total": 16,
      "dental": 0,
      "healthcare": 1,
      "non_healthcare": 15
    },
    {
      "start": "2025-05-01 00:00:00",
      "end": "2025-05-31 23:59:59",
      "unit_date": "2025-05-01",
      "total": 197,
      "dental": 1,
      "healthcare": 1,
      "non_healthcare": 195
    },
    {
      "start": "2025-06-01 00:00:00",
      "end": "2025-06-30 23:59:59",
      "unit_date": "2025-06-01",
      "total": 215,
      "dental": 6,
      "healthcare": 2,
      "non_healthcare": 207
    },
    {
      "start": "2025-07-01 00:00:00",
      "end": "2025-07-26 23:59:59",
      "unit_date": "2025-07-01",
      "total": 118,
      "dental": 2,
      "healthcare": 7,
      "non_healthcare": 109
    }
  ]
};

export const activatedBusinessesData = {
  "stats": {
    "total": 15,
    "dental": 0,
    "healthcare": 0,
    "non_healthcare": 15
  },
  "records": [
    {
      "start": "2025-04-25 00:00:00",
      "end": "2025-04-30 23:59:59",
      "unit_date": "2025-04-01",
      "total": 3,
      "dental": 0,
      "healthcare": 0,
      "non_healthcare": 3
    },
    {
      "start": "2025-05-01 00:00:00",
      "end": "2025-05-31 23:59:59",
      "unit_date": "2025-05-01",
      "total": 6,
      "dental": 0,
      "healthcare": 0,
      "non_healthcare": 6
    },
    {
      "start": "2025-06-01 00:00:00",
      "end": "2025-06-30 23:59:59",
      "unit_date": "2025-06-01",
      "total": 4,
      "dental": 0,
      "healthcare": 0,
      "non_healthcare": 4
    },
    {
      "start": "2025-07-01 00:00:00",
      "end": "2025-07-26 23:59:59",
      "unit_date": "2025-07-01",
      "total": 2,
      "dental": 0,
      "healthcare": 0,
      "non_healthcare": 2
    }
  ]
};

export const revivedBusinessesData = {
  "stats": {
    "total": 57,
    "dental": 8,
    "healthcare": 10,
    "non_healthcare": 39
  },
  "records": [
    {
      "start": "2025-07-27 00:00:00",
      "end": "2025-07-31 23:59:59",
      "unit_date": "2025-07-01",
      "total": 4,
      "dental": 1,
      "healthcare": 0,
      "non_healthcare": 3
    },
    {
      "start": "2025-08-01 00:00:00",
      "end": "2025-08-31 23:59:59",
      "unit_date": "2025-08-01",
      "total": 22,
      "dental": 3,
      "healthcare": 3,
      "non_healthcare": 16
    },
    {
      "start": "2025-09-01 00:00:00",
      "end": "2025-09-30 23:59:59",
      "unit_date": "2025-09-01",
      "total": 22,
      "dental": 2,
      "healthcare": 4,
      "non_healthcare": 16
    },
    {
      "start": "2025-10-01 00:00:00",
      "end": "2025-10-27 23:59:59",
      "unit_date": "2025-10-01",
      "total": 9,
      "dental": 2,
      "healthcare": 3,
      "non_healthcare": 4
    }
  ]
};

export const businessStages = [
  {
    "stage": 1,
    "name": "Registered"
  },
  {
    "stage": 2,
    "name": "Registration Complete"
  },
  {
    "stage": 3,
    "name": "Registration Incomplete"
  },
  {
    "stage": 4,
    "name": "Approved"
  },
  {
    "stage": 5,
    "name": "Disapproved"
  },
  {
    "stage": 6,
    "name": "Approval Pending"
  },
  {
    "stage": 7,
    "name": "Blocked"
  },
  {
    "stage": 8,
    "name": "Unblocked"
  },
  {
    "stage": 9,
    "name": "Training Done"
  },
  {
    "stage": 10,
    "name": "Training Not Done"
  }
];

export const businessPhases = [
  {
    "phase_name": "Activation",
    "phase_ids": "10"
  },
  {
    "phase_name": "Low Potential - Manual",
    "phase_ids": "6"
  },
  {
    "phase_name": "Low Potential Automatic",
    "phase_ids": "5"
  },
  {
    "phase_name": "Phase 0",
    "phase_ids": "1"
  },
  {
    "phase_name": "Phase 1",
    "phase_ids": "2"
  },
  {
    "phase_name": "Phase 2",
    "phase_ids": "3"
  },
  {
    "phase_name": "Phase 3",
    "phase_ids": "4"
  },
  {
    "phase_name": "Retention - Manual",
    "phase_ids": "8"
  },
  {
    "phase_name": "Retention Automatic",
    "phase_ids": "7"
  },
  {
    "phase_name": "Revival",
    "phase_ids": "9,11,12,13"
  }
];

export const businessStageData = {
  "stats": {
    "total": 228,
    "dental": 46,
    "healthcare": 40,
    "non_healthcare": 142
  },
  "records": [
    {
      "start": "2025-07-27 00:00:00",
      "end": "2025-07-31 23:59:59",
      "unit_date": "2025-07-01",
      "total": 14,
      "dental": 3,
      "healthcare": 0,
      "non_healthcare": 11
    },
    {
      "start": "2025-08-01 00:00:00",
      "end": "2025-08-31 23:59:59",
      "unit_date": "2025-08-01",
      "total": 88,
      "dental": 15,
      "healthcare": 6,
      "non_healthcare": 67
    },
    {
      "start": "2025-09-01 00:00:00",
      "end": "2025-09-30 23:59:59",
      "unit_date": "2025-09-01",
      "total": 66,
      "dental": 16,
      "healthcare": 8,
      "non_healthcare": 42
    },
    {
      "start": "2025-10-01 00:00:00",
      "end": "2025-10-27 23:59:59",
      "unit_date": "2025-10-01",
      "total": 60,
      "dental": 12,
      "healthcare": 26,
      "non_healthcare": 22
    }
  ]
};

export const businessHighlightsLoserData = {
  "currentPeriod": "Jul 27, 2025 to Oct 27, 2025",
  "previousPeriod": "Apr 26, 2025 to Jul 26, 2025",
  "records": [
    {
      "doctor_id": 94927,
      "practice_name": "dental bridginging association",
      "doctor_name": "Rahul dev live business T 26 may 2025",
      "current_period_count": 24,
      "previous_period_count": 262,
      "count_diff": -238
    },
    {
      "doctor_id": 91048,
      "practice_name": "Practice QA",
      "doctor_name": "Aashima1 NH",
      "current_period_count": 120,
      "previous_period_count": 340,
      "count_diff": -220
    },
    {
      "doctor_id": 94485,
      "practice_name": "Dental Plus",
      "doctor_name": "Dental Plus",
      "current_period_count": 0,
      "previous_period_count": 159,
      "count_diff": -159
    },
    {
      "doctor_id": 9196,
      "practice_name": "Shubhneet Walia",
      "doctor_name": "Shubhneet Walia",
      "current_period_count": 0,
      "previous_period_count": 118,
      "count_diff": -118
    },
    {
      "doctor_id": 94407,
      "practice_name": "Smart Dental Care",
      "doctor_name": "Android Stripe Updates",
      "current_period_count": 2,
      "previous_period_count": 84,
      "count_diff": -82
    },
    {
      "doctor_id": 95137,
      "practice_name": "Test",
      "doctor_name": "transaction fee",
      "current_period_count": 0,
      "previous_period_count": 78,
      "count_diff": -78
    },
    {
      "doctor_id": 94850,
      "practice_name": "Dental 19 May 2025",
      "doctor_name": "Rahul dev 19 may 2025",
      "current_period_count": 47,
      "previous_period_count": 123,
      "count_diff": -76
    },
    {
      "doctor_id": 93453,
      "practice_name": "test",
      "doctor_name": "Pulkit Saini",
      "current_period_count": 0,
      "previous_period_count": 66,
      "count_diff": -66
    },
    {
      "doctor_id": 92835,
      "practice_name": "testing",
      "doctor_name": "Testing Pp",
      "current_period_count": 23,
      "previous_period_count": 86,
      "count_diff": -63
    },
    {
      "doctor_id": 94821,
      "practice_name": "Lendee Integration By Manoj",
      "doctor_name": "manoj kumar",
      "current_period_count": 2,
      "previous_period_count": 52,
      "count_diff": -50
    }
  ]
};

export const trendingIndustriesData = {
  "currentPeriod": "Jul 27, 2025 to Oct 27, 2025",
  "previousPeriod": "Apr 26, 2025 to Jul 26, 2025",
  "dental": [
    {
      "industry": "dental",
      "speciality_name": "General Dentistry",
      "current_period_count": "310",
      "previous_period_count": "340",
      "count_diff": "-30"
    },
    {
      "industry": "dental",
      "speciality_name": "Dental Veneers",
      "current_period_count": "15",
      "previous_period_count": "0",
      "count_diff": "15"
    },
    {
      "industry": "dental",
      "speciality_name": "Tooth Extractions",
      "current_period_count": "9",
      "previous_period_count": "0",
      "count_diff": "9"
    },
    {
      "industry": "dental",
      "speciality_name": "Bridgework",
      "current_period_count": "6",
      "previous_period_count": "0",
      "count_diff": "6"
    },
    {
      "industry": "dental",
      "speciality_name": "Teeth Whitening",
      "current_period_count": "5",
      "previous_period_count": "6",
      "count_diff": "-1"
    },
    {
      "industry": "dental",
      "speciality_name": "Dental Sealants",
      "current_period_count": "4",
      "previous_period_count": "0",
      "count_diff": "4"
    },
    {
      "industry": "dental",
      "speciality_name": "Root Canal Therapy",
      "current_period_count": "4",
      "previous_period_count": "0",
      "count_diff": "4"
    },
    {
      "industry": "dental",
      "speciality_name": "Clear Aligners",
      "current_period_count": "2",
      "previous_period_count": "5",
      "count_diff": "-3"
    },
    {
      "industry": "dental",
      "speciality_name": "Dentures",
      "current_period_count": "1",
      "previous_period_count": "0",
      "count_diff": "1"
    },
    {
      "industry": "dental",
      "speciality_name": "Endodontist",
      "current_period_count": "1",
      "previous_period_count": "3",
      "count_diff": "-2"
    }
  ],
  "healthcare": [
    {
      "industry": "healthcare",
      "speciality_name": "Cryotherapy",
      "current_period_count": "98",
      "previous_period_count": "0",
      "count_diff": "98"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Chiropractors",
      "current_period_count": "67",
      "previous_period_count": "8",
      "count_diff": "59"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Dietitians",
      "current_period_count": "36",
      "previous_period_count": "19",
      "count_diff": "17"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Chiropractic",
      "current_period_count": "11",
      "previous_period_count": "58",
      "count_diff": "-47"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Plastic Surgeons",
      "current_period_count": "10",
      "previous_period_count": "0",
      "count_diff": "10"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Mental Health & Pain Treatment",
      "current_period_count": "6",
      "previous_period_count": "5",
      "count_diff": "1"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Medspa",
      "current_period_count": "2",
      "previous_period_count": "0",
      "count_diff": "2"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Men's Health",
      "current_period_count": "2",
      "previous_period_count": "1",
      "count_diff": "1"
    },
    {
      "industry": "healthcare",
      "speciality_name": "Mental Health Clinic",
      "current_period_count": "2",
      "previous_period_count": "150",
      "count_diff": "-148"
    },
    {
      "industry": "healthcare",
      "speciality_name": "aesthetics",
      "current_period_count": "0",
      "previous_period_count": "0",
      "count_diff": "0"
    }
  ],
  "non_healthcare": [
    {
      "industry": "non_healthcare",
      "speciality_name": "Sassies Exclusive Apparel LLC",
      "current_period_count": "239",
      "previous_period_count": "463",
      "count_diff": "-224"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Day care",
      "current_period_count": "168",
      "previous_period_count": "299",
      "count_diff": "-131"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Restaurant",
      "current_period_count": "120",
      "previous_period_count": "343",
      "count_diff": "-223"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "hdhdh",
      "current_period_count": "68",
      "previous_period_count": "70",
      "count_diff": "-2"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Wellness",
      "current_period_count": "55",
      "previous_period_count": "241",
      "count_diff": "-186"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Coaching services and retreats",
      "current_period_count": "47",
      "previous_period_count": "46",
      "count_diff": "1"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Electronics Producers",
      "current_period_count": "45",
      "previous_period_count": "0",
      "count_diff": "45"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Body contouring",
      "current_period_count": "32",
      "previous_period_count": "57",
      "count_diff": "-25"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "Furniture",
      "current_period_count": "25",
      "previous_period_count": "46",
      "count_diff": "-21"
    },
    {
      "industry": "non_healthcare",
      "speciality_name": "home",
      "current_period_count": "25",
      "previous_period_count": "15",
      "count_diff": "10"
    }
  ]
};

export const businessPhasesData = {
  "stats": {
    "total": 228,
    "dental": 46,
    "healthcare": 40,
    "non_healthcare": 142
  },
  "records": [
    {
      "start": "2025-07-27 00:00:00",
      "end": "2025-07-31 23:59:59",
      "unit_date": "2025-07-01",
      "total": 14,
      "dental": 3,
      "healthcare": 0,
      "non_healthcare": 11
    },
    {
      "start": "2025-08-01 00:00:00",
      "end": "2025-08-31 23:59:59",
      "unit_date": "2025-08-01",
      "total": 88,
      "dental": 15,
      "healthcare": 6,
      "non_healthcare": 67
    },
    {
      "start": "2025-09-01 00:00:00",
      "end": "2025-09-30 23:59:59",
      "unit_date": "2025-09-01",
      "total": 66,
      "dental": 16,
      "healthcare": 8,
      "non_healthcare": 42
    },
    {
      "start": "2025-10-01 00:00:00",
      "end": "2025-10-27 23:59:59",
      "unit_date": "2025-10-01",
      "total": 60,
      "dental": 12,
      "healthcare": 26,
      "non_healthcare": 22
    }
  ]
};

export const activeBusinessesRangeData = [
  {
    "year": 2023,
    "stats": {
      "total": 1079,
      "dental": 255,
      "healthcare": 188,
      "non_healthcare": 636
    },
    "data": [
      {
        "start": "2023-01-01 00:00:00",
        "end": "2023-01-31 23:59:59",
        "total": 147,
        "dental": 31,
        "healthcare": 24,
        "non_healthcare": 92,
        "month_short": "Jan",
        "month_long": "January"
      },
      {
        "start": "2023-02-01 00:00:00",
        "end": "2023-02-28 23:59:59",
        "total": 129,
        "dental": 34,
        "healthcare": 30,
        "non_healthcare": 65,
        "month_short": "Feb",
        "month_long": "February"
      },
      {
        "start": "2023-03-01 00:00:00",
        "end": "2023-03-31 23:59:59",
        "total": 97,
        "dental": 19,
        "healthcare": 17,
        "non_healthcare": 61,
        "month_short": "Mar",
        "month_long": "March"
      },
      {
        "start": "2023-04-01 00:00:00",
        "end": "2023-04-30 23:59:59",
        "total": 124,
        "dental": 32,
        "healthcare": 19,
        "non_healthcare": 73,
        "month_short": "Apr",
        "month_long": "April"
      },
      {
        "start": "2023-05-01 00:00:00",
        "end": "2023-05-31 23:59:59",
        "total": 96,
        "dental": 23,
        "healthcare": 14,
        "non_healthcare": 59,
        "month_short": "May",
        "month_long": "May"
      },
      {
        "start": "2023-06-01 00:00:00",
        "end": "2023-06-30 23:59:59",
        "total": 70,
        "dental": 16,
        "healthcare": 11,
        "non_healthcare": 43,
        "month_short": "Jun",
        "month_long": "June"
      },
      {
        "start": "2023-07-01 00:00:00",
        "end": "2023-07-31 23:59:59",
        "total": 74,
        "dental": 17,
        "healthcare": 16,
        "non_healthcare": 41,
        "month_short": "Jul",
        "month_long": "July"
      },
      {
        "start": "2023-08-01 00:00:00",
        "end": "2023-08-31 23:59:59",
        "total": 61,
        "dental": 17,
        "healthcare": 12,
        "non_healthcare": 32,
        "month_short": "Aug",
        "month_long": "August"
      },
      {
        "start": "2023-09-01 00:00:00",
        "end": "2023-09-30 23:59:59",
        "total": 66,
        "dental": 21,
        "healthcare": 7,
        "non_healthcare": 38,
        "month_short": "Sep",
        "month_long": "September"
      },
      {
        "start": "2023-10-01 00:00:00",
        "end": "2023-10-31 23:59:59",
        "total": 70,
        "dental": 15,
        "healthcare": 14,
        "non_healthcare": 41,
        "month_short": "Oct",
        "month_long": "October"
      },
      {
        "start": "2023-11-01 00:00:00",
        "end": "2023-11-30 23:59:59",
        "total": 55,
        "dental": 13,
        "healthcare": 11,
        "non_healthcare": 31,
        "month_short": "Nov",
        "month_long": "November"
      },
      {
        "start": "2023-12-01 00:00:00",
        "end": "2023-12-31 23:59:59",
        "total": 90,
        "dental": 17,
        "healthcare": 13,
        "non_healthcare": 60,
        "month_short": "Dec",
        "month_long": "December"
      }
    ]
  },
  {
    "year": 2024,
    "stats": {
      "total": 1612,
      "dental": 188,
      "healthcare": 177,
      "non_healthcare": 1247
    },
    "data": [
      {
        "start": "2024-01-01 00:00:00",
        "end": "2024-01-31 23:59:59",
        "total": 395,
        "dental": 21,
        "healthcare": 16,
        "non_healthcare": 358,
        "month_short": "Jan",
        "month_long": "January"
      },
      {
        "start": "2024-02-01 00:00:00",
        "end": "2024-02-29 23:59:59",
        "total": 456,
        "dental": 21,
        "healthcare": 13,
        "non_healthcare": 422,
        "month_short": "Feb",
        "month_long": "February"
      },
      {
        "start": "2024-03-01 00:00:00",
        "end": "2024-03-31 23:59:59",
        "total": 107,
        "dental": 18,
        "healthcare": 13,
        "non_healthcare": 76,
        "month_short": "Mar",
        "month_long": "March"
      },
      {
        "start": "2024-04-01 00:00:00",
        "end": "2024-04-30 23:59:59",
        "total": 112,
        "dental": 19,
        "healthcare": 28,
        "non_healthcare": 65,
        "month_short": "Apr",
        "month_long": "April"
      },
      {
        "start": "2024-05-01 00:00:00",
        "end": "2024-05-31 23:59:59",
        "total": 76,
        "dental": 18,
        "healthcare": 16,
        "non_healthcare": 42,
        "month_short": "May",
        "month_long": "May"
      },
      {
        "start": "2024-06-01 00:00:00",
        "end": "2024-06-30 23:59:59",
        "total": 71,
        "dental": 18,
        "healthcare": 13,
        "non_healthcare": 40,
        "month_short": "Jun",
        "month_long": "June"
      },
      {
        "start": "2024-07-01 00:00:00",
        "end": "2024-07-31 23:59:59",
        "total": 55,
        "dental": 11,
        "healthcare": 9,
        "non_healthcare": 35,
        "month_short": "Jul",
        "month_long": "July"
      },
      {
        "start": "2024-08-01 00:00:00",
        "end": "2024-08-31 23:59:59",
        "total": 82,
        "dental": 17,
        "healthcare": 16,
        "non_healthcare": 49,
        "month_short": "Aug",
        "month_long": "August"
      },
      {
        "start": "2024-09-01 00:00:00",
        "end": "2024-09-30 23:59:59",
        "total": 72,
        "dental": 14,
        "healthcare": 16,
        "non_healthcare": 42,
        "month_short": "Sep",
        "month_long": "September"
      },
      {
        "start": "2024-10-01 00:00:00",
        "end": "2024-10-31 23:59:59",
        "total": 72,
        "dental": 8,
        "healthcare": 16,
        "non_healthcare": 48,
        "month_short": "Oct",
        "month_long": "October"
      },
      {
        "start": "2024-11-01 00:00:00",
        "end": "2024-11-30 23:59:59",
        "total": 71,
        "dental": 14,
        "healthcare": 12,
        "non_healthcare": 45,
        "month_short": "Nov",
        "month_long": "November"
      },
      {
        "start": "2024-12-01 00:00:00",
        "end": "2024-12-31 23:59:59",
        "total": 43,
        "dental": 9,
        "healthcare": 9,
        "non_healthcare": 25,
        "month_short": "Dec",
        "month_long": "December"
      }
    ]
  },
  {
    "year": 2025,
    "stats": {
      "total": 859,
      "dental": 92,
      "healthcare": 99,
      "non_healthcare": 669
    },
    "data": [
      {
        "start": "2025-01-01 00:00:00",
        "end": "2025-01-31 23:59:59",
        "total": 58,
        "dental": 11,
        "healthcare": 18,
        "non_healthcare": 29,
        "month_short": "Jan",
        "month_long": "January"
      },
      {
        "start": "2025-02-01 00:00:00",
        "end": "2025-02-28 23:59:59",
        "total": 54,
        "dental": 15,
        "healthcare": 12,
        "non_healthcare": 27,
        "month_short": "Feb",
        "month_long": "February"
      },
      {
        "start": "2025-03-01 00:00:00",
        "end": "2025-03-31 23:59:59",
        "total": 223,
        "dental": 12,
        "healthcare": 16,
        "non_healthcare": 196,
        "month_short": "Mar",
        "month_long": "March"
      },
      {
        "start": "2025-04-01 00:00:00",
        "end": "2025-04-30 23:59:59",
        "total": 79,
        "dental": 10,
        "healthcare": 7,
        "non_healthcare": 62,
        "month_short": "Apr",
        "month_long": "April"
      },
      {
        "start": "2025-05-01 00:00:00",
        "end": "2025-05-31 23:59:59",
        "total": 94,
        "dental": 9,
        "healthcare": 4,
        "non_healthcare": 81,
        "month_short": "May",
        "month_long": "May"
      },
      {
        "start": "2025-06-01 00:00:00",
        "end": "2025-06-30 23:59:59",
        "total": 119,
        "dental": 7,
        "healthcare": 7,
        "non_healthcare": 105,
        "month_short": "Jun",
        "month_long": "June"
      },
      {
        "start": "2025-07-01 00:00:00",
        "end": "2025-07-31 23:59:59",
        "total": 99,
        "dental": 9,
        "healthcare": 14,
        "non_healthcare": 76,
        "month_short": "Jul",
        "month_long": "July"
      },
      {
        "start": "2025-08-01 00:00:00",
        "end": "2025-08-31 23:59:59",
        "total": 53,
        "dental": 8,
        "healthcare": 9,
        "non_healthcare": 36,
        "month_short": "Aug",
        "month_long": "August"
      },
      {
        "start": "2025-09-01 00:00:00",
        "end": "2025-09-30 23:59:59",
        "total": 45,
        "dental": 5,
        "healthcare": 6,
        "non_healthcare": 34,
        "month_short": "Sep",
        "month_long": "September"
      },
      {
        "start": "2025-10-01 00:00:00",
        "end": "2025-10-28 00:59:59",
        "total": 35,
        "dental": 6,
        "healthcare": 6,
        "non_healthcare": 23,
        "month_short": "Oct",
        "month_long": "October"
      }
    ]
  }
];

export const cohortGroupData = [
  {
    "start": "2025-01-01 00:00:00",
    "end": "2025-01-31 23:59:59",
    "unit_date": "2025-01-01",
    "cohort_size": 66,
    "active_users": 16,
    "retention_rate": 24.24
  },
  {
    "start": "2025-02-01 00:00:00",
    "end": "2025-02-28 23:59:59",
    "unit_date": "2025-02-01",
    "cohort_size": 66,
    "active_users": 8,
    "retention_rate": 12.12
  },
  {
    "start": "2025-03-01 00:00:00",
    "end": "2025-03-31 23:59:59",
    "unit_date": "2025-03-01",
    "cohort_size": 66,
    "active_users": 3,
    "retention_rate": 4.55
  },
  {
    "start": "2025-04-01 00:00:00",
    "end": "2025-04-30 23:59:59",
    "unit_date": "2025-04-01",
    "cohort_size": 66,
    "active_users": 2,
    "retention_rate": 3.03
  },
  {
    "start": "2025-05-01 00:00:00",
    "end": "2025-05-31 23:59:59",
    "unit_date": "2025-05-01",
    "cohort_size": 66,
    "active_users": 3,
    "retention_rate": 4.55
  },
  {
    "start": "2025-06-01 00:00:00",
    "end": "2025-06-30 23:59:59",
    "unit_date": "2025-06-01",
    "cohort_size": 66,
    "active_users": 1,
    "retention_rate": 1.52
  },
  {
    "start": "2025-07-01 00:00:00",
    "end": "2025-07-31 23:59:59",
    "unit_date": "2025-07-01",
    "cohort_size": 66,
    "active_users": 2,
    "retention_rate": 3.03
  },
  {
    "start": "2025-08-01 00:00:00",
    "end": "2025-08-31 23:59:59",
    "unit_date": "2025-08-01",
    "cohort_size": 66,
    "active_users": 1,
    "retention_rate": 1.52
  },
  {
    "start": "2025-09-01 00:00:00",
    "end": "2025-09-30 23:59:59",
    "unit_date": "2025-09-01",
    "cohort_size": 66,
    "active_users": 0,
    "retention_rate": 0
  },
  {
    "start": "2025-10-01 00:00:00",
    "end": "2025-10-28 00:59:59",
    "unit_date": "2025-10-01",
    "cohort_size": 66,
    "active_users": 0,
    "retention_rate": 0
  }
];

